"use client";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from "react";
import { ThemeProvider as StyledComponentsThemeProvider, createGlobalStyle } from "styled-components";
import { Normalize } from "styled-normalize";
import { colorDarkest, copyColor, copyFontFamily, copyLineHeight } from "./selectors";
import { brandFonts } from "./fonts";
import { formTypes } from "./types";
var Reset = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html {\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    /* Not setting font-size because we want 16px */\n    font-display: swap;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.id === "nib" ? colorDarkest : copyColor;
}, copyFontFamily, function (_ref2) {
  var theme = _ref2.theme;
  return theme.copy.fontWeight;
}, copyLineHeight);
var Theme = function Theme(_ref3) {
  var children = _ref3.children,
    theme = _ref3.theme,
    mode = _ref3.mode;
  var themeWithFormMode = mode ? _objectSpread(_objectSpread({}, theme), {}, {
    mode: mode
  }) : theme;
  var BrandFonts = brandFonts[theme.id];
  return /*#__PURE__*/React.createElement(StyledComponentsThemeProvider, {
    theme: themeWithFormMode
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Normalize, null), /*#__PURE__*/React.createElement(Reset, null), BrandFonts && /*#__PURE__*/React.createElement(BrandFonts, null), children));
};
Theme.displayName = "Theme";
export default Theme;
export * from "./selectors";
export * from "./brands";
export * from "./types";
export * from "./common";